import React, { useEffect, useState } from "react";
import Layouts from "../../components/Layouts";
import { getDirectusClient } from "../../lib/directus";
import { readItems } from "@directus/sdk";
import validarpermiso from "../../lib/utils";
import { useSelector } from "react-redux";
import { DatePicker, Space, Tag, message, Table, Tabs, Row, Col } from "antd";

import moment from "moment";

import { Column } from "@ant-design/plots";

function Reporte(props) {
  const [gestiones, setGestiones] = useState([]);
  const [loading, setLoading] = useState(false);
  const permisos = useSelector((state) => state.permisos);
  const userBodega = useSelector((state) => state.userdata.bodega?.id);
  const [selectedDate, setSelectedDate] = useState(moment());
  const [activeTab, setActiveTab] = useState("todos");
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [pageSize] = useState(20);
  const userRoleID = useSelector((state) => state.userdata.role.name);
  const weekdayMap = {
    monday: { id: 1, name: "Lunes" },
    tuesday: { id: 2, name: "Martes" },
    wednesday: { id: 3, name: "Miércoles" },
    thursday: { id: 4, name: "Jueves" },
    friday: { id: 5, name: "Viernes" },
    saturday: { id: 6, name: "Sábado" },
    sunday: { id: 7, name: "Domingo" },
  };

  const getColumns = (getStatusColor) => [
    {
      title: "Vendedor",
      key: "vendedor",
      render: (_, record) => (
        <Space>
          <span>
            {record.vendedor?.first_name} {record.vendedor?.last_name}
          </span>
        </Space>
      ),
    },
    {
      title: "Estado",
      key: "estado",
      render: (_, record) => (
        <Tag color={getStatusColor(record.estado?.estado)}>
          {record.estado?.estado}
        </Tag>
      ),
    },
    {
      title: "Circuito",
      key: "circuito",
      render: (_, record) => (
        <Space direction="vertical">
          {record.vendedor?.circuitos_vendedor?.map((circuito) => (
            <div key={circuito.id}>
              <div> {circuito.nombre}</div>
            </div>
          ))}
        </Space>
      ),
    },
    {
      title: "Cliente",
      key: "cliente",
      render: (_, record) => (
        <span>
          {record.cliente?.first_name} {record.cliente?.last_name}
        </span>
      ),
    },
    {
      title: "Ruta",
      dataIndex: "ruta",
      key: "ruta",
      render: (_, record) => (
        <Space direction="vertical">
          {record.vendedor?.circuitos_vendedor?.map((circuito) => (
            <div key={circuito.id}>
              <div>{circuito.ruta?.nombre}</div>
            </div>
          ))}
        </Space>
      ),
    },
  ];

  const getGestiones = async (date, currentPage = 1) => {
    setLoading(true);
    const directus = await getDirectusClient();
    try {
      const dayName = date.format("dddd").toLowerCase();
      const dayId = weekdayMap[dayName].id;

      const newGestiones = await directus.request(
        readItems("gestion_cliente_rutero", {
          fields: [
            "id",
            "date_created",
            "vendedor.id",
            "vendedor.first_name",
            "vendedor.last_name",
            "vendedor.circuitos_vendedor.id",
            "vendedor.circuitos_vendedor.nombre",
            "vendedor.circuitos_vendedor.dias.dias_id.dia",
            "vendedor.circuitos_vendedor.dias.dias_id.id",
            "vendedor.circuitos_vendedor.clientes.id",
            "vendedor.circuitos_vendedor.ruta.nombre",
            "cliente.id",
            "cliente.first_name",
            "cliente.last_name",
            "estado.estado",
          ],
          filter: {
            _and: [
              {
                vendedor: {
                  circuitos_vendedor: {
                    dias: {
                      dias_id: {
                        id: {
                          _eq: dayId,
                        },
                      },
                    },
                  },
                },
              },
              {
                date_created: {
                  _gte: date.startOf("day").toISOString(),
                  _lte: date.endOf("day").toISOString(),
                },
              },
              {
                vendedor: {
                  _nnull: true,
                },
              },
            ],
            ...(userRoleID !== "adminapp" && userRoleID !== "Administrator"
              ? {
                  bodega: {
                    id: { _eq: userBodega },
                  },
                }
              : {}),
          },
          sort: ["-date_created"],
          limit: pageSize,
          page: currentPage,
        })
      );

      if (newGestiones.length < pageSize) {
        setHasMore(false);
      }

      if (currentPage === 1) {
        setGestiones(newGestiones);
      } else {
        setGestiones((prev) => [...prev, ...newGestiones]);
      }

      setPage(currentPage);
    } catch (err) {
      console.error("Error fetching data:", err);
      message.error("Error al cargar las gestiones");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getGestiones(selectedDate);
  }, []);

  const getGestionesByStatus = (gestiones) => {
    return gestiones.reduce(
      (acc, gestion) => {
        const status = gestion.estado?.estado || "pendiente";
        if (!acc[status]) {
          acc[status] = [];
        }
        acc[status].push(gestion);
        return acc;
      },
      { todos: gestiones }
    );
  };

  const getStatusColor = (status) => {
    switch (status) {
      case "activo":
        return "red";
      case "gestion iniciada":
        return "yellow";
      case "gestianado":
        return "green";
      case "cliente ausente":
        return "default";
      default:
        return "default";
    }
  };

  return (
    <Layouts>
      {validarpermiso("rutas", "read", permisos) ? (
        <Space direction="vertical" size="large" style={{ width: "100%" }}>
          <Space align="center">
            <DatePicker
              onChange={(date) => {
                setSelectedDate(date || moment());
                getGestiones(date || moment());
              }}
              format="DD/MM/YYYY"
              allowClear={false}
            />
            <Tag color="blue">
              {weekdayMap[selectedDate.format("dddd").toLowerCase()].name}
            </Tag>
          </Space>
          <Row>
            <Col span={12}>
              <Tabs
                activeKey={activeTab}
                onChange={setActiveTab}
                items={[
                  {
                    key: "todos",
                    label: `Todos (${gestiones.length})`,
                    children: (
                      <div
                        id={`scrollableDiv-todos`}
                        style={{
                          height: "calc(100vh - 300px)",
                          overflow: "auto",
                          padding: "0 16px",
                        }}
                      >
                        <Table
                          loading={loading}
                          columns={getColumns(getStatusColor)}
                          dataSource={gestiones}
                          pagination={false}
                          rowKey="id"
                          scroll={{ y: "calc(100vh - 400px)" }}
                        />
                      </div>
                    ),
                  },
                  {
                    key: "activo",
                    label: `Activos (${
                      getGestionesByStatus(gestiones).activo?.length || 0
                    })`,
                    children: (
                      <div
                        id={`scrollableDiv-activo`}
                        style={{
                          height: "calc(100vh - 300px)",
                          overflow: "auto",
                          padding: "0 16px",
                        }}
                      >
                        <Table
                          loading={loading}
                          columns={getColumns(getStatusColor)}
                          dataSource={
                            getGestionesByStatus(gestiones).activo || []
                          }
                          pagination={false}
                          rowKey="id"
                          scroll={{ y: "calc(100vh - 400px)" }}
                        />
                      </div>
                    ),
                  },
                  {
                    key: "gestion iniciada",
                    label: `Iniciados (${
                      getGestionesByStatus(gestiones)["gestion iniciada"]
                        ?.length || 0
                    })`,
                    children: (
                      <div
                        id={`scrollableDiv-gestion-iniciada`}
                        style={{
                          height: "calc(100vh - 300px)",
                          overflow: "auto",
                          padding: "0 16px",
                        }}
                      >
                        <Table
                          loading={loading}
                          columns={getColumns(getStatusColor)}
                          dataSource={
                            getGestionesByStatus(gestiones)[
                              "gestion iniciada"
                            ] || []
                          }
                          pagination={false}
                          rowKey="id"
                          scroll={{ y: "calc(100vh - 400px)" }}
                        />
                      </div>
                    ),
                  },
                  {
                    key: "gestianado",
                    label: `Gestionados (${
                      getGestionesByStatus(gestiones).gestianado?.length || 0
                    })`,
                    children: (
                      <div
                        id={`scrollableDiv-gestianado`}
                        style={{
                          height: "calc(100vh - 300px)",
                          overflow: "auto",
                          padding: "0 16px",
                        }}
                      >
                        <Table
                          loading={loading}
                          columns={getColumns(getStatusColor)}
                          dataSource={
                            getGestionesByStatus(gestiones).gestianado || []
                          }
                          pagination={false}
                          rowKey="id"
                          scroll={{ y: "calc(100vh - 400px)" }}
                        />
                      </div>
                    ),
                  },
                  {
                    key: "cliente ausente",
                    label: `Ausentes (${
                      getGestionesByStatus(gestiones)["cliente ausente"]
                        ?.length || 0
                    })`,
                    children: (
                      <div
                        id={`scrollableDiv-cliente-ausente`}
                        style={{
                          height: "calc(100vh - 300px)",
                          overflow: "auto",
                          padding: "0 16px",
                        }}
                      >
                        <Table
                          loading={loading}
                          columns={getColumns(getStatusColor)}
                          dataSource={
                            getGestionesByStatus(gestiones)[
                              "cliente ausente"
                            ] || []
                          }
                          pagination={false}
                          rowKey="id"
                          scroll={{ y: "calc(100vh - 400px)" }}
                        />
                      </div>
                    ),
                  },
                ]}
              />
            </Col>
            <Col span={12}>
              <div
                style={{
                  padding: "24px",
                  backgroundColor: "white",
                  borderRadius: "8px",
                }}
              >
                <h3>Gestiones por Vendedor</h3>
                <Column
                  data={
                    // Group gestiones by vendor
                    Object.entries(
                      gestiones.reduce((acc, gestion) => {
                        const vendedorName = `${gestion.vendedor?.first_name} ${gestion.vendedor?.last_name}`;
                        if (!acc[vendedorName]) {
                          acc[vendedorName] = {
                            total: 0,
                            activo: 0,
                            "gestion iniciada": 0,
                            gestionado: 0,
                            "cliente ausente": 0,
                          };
                        }
                        acc[vendedorName].total += 1;
                        acc[vendedorName][gestion.estado?.estado] += 1;
                        return acc;
                      }, {})
                    ).map(([vendedor, stats]) => ({
                      vendedor,
                      gestiones: stats.total,
                      activos: stats.activo,
                      iniciados: stats["gestion iniciada"],
                      gestionados: stats.gestionado,
                      ausentes: stats["cliente ausente"],
                    }))
                  }
                  xField="vendedor"
                  yField="gestiones"
                  label={{
                    style: {
                      fill: "#FFFFFF",
                      opacity: 0.8,
                    },
                  }}
                  xAxis={{
                    label: {
                      autoRotate: true,
                      autoHide: false,
                      autoEllipsis: true,
                    },
                  }}
                  tooltip={{
                    title: "Vendedor",
                    formatter: (datum) => {
                      return [
                        { name: "Total Gestiones", value: datum.gestiones },
                        { name: "Activos", value: datum.activos },
                        { name: "Iniciados", value: datum.iniciados },
                        { name: "Gestionados", value: datum.gestionados },
                        { name: "Ausentes", value: datum.ausentes },
                      ];
                    },
                  }}
                  meta={{
                    vendedor: {
                      alias: "Vendedor",
                    },
                    gestiones: {
                      alias: "Total Gestiones",
                    },
                  }}
                  color="#1890ff"
                  columnStyle={{
                    radius: [4, 4, 0, 0],
                  }}
                />
              </div>
            </Col>
          </Row>
        </Space>
      ) : (
        <h3>No tiene permisos para ver rutas</h3>
      )}
    </Layouts>
  );
}

export default Reporte;
